import Box, { BoxProps } from '@mui/material/Box';
import clsx from 'clsx';
import { Size } from '../utils';

export default function Icon({
  className,
  icon,
  size,
  spin = false,
  sx,
  title,
  ...rest
}: IconProps) {
  const isFabStyle = Boolean(fabStyles[icon]);
  const classes = clsx(`fa-${icon}`, className, {
    'fa-spin': spin,
    'fab': isFabStyle,
    'fas': !isFabStyle,
  });

  const fontSize = typeof size === 'string' ? Icon.SIZES[size] : size;

  return (
    <Box
      className={classes}
      component="span"
      sx={{ fontSize, ml: 0, mr: 1, textAlign: 'center', ...sx }}
      title={title}
      {...rest}
    />
  );
}

Icon.SIZES = {
  small: 16,
  medium: 24,
  large: 32,
};

export interface IconProps extends BoxProps {
  icon: IconName;
  size?: Size;
  spin?: boolean;
  title?: string;
}

export type OptionalIconProps = Partial<IconProps>;

const fabStyles: Partial<Record<IconName, boolean>> = {
  'apple': true,
  'creative-commons-zero': true,
  'linux': true,
  'squarespace': true,
  'windows': true,
};

export type IconName =
  | '500px'
  | 'accessible-icon'
  | 'accusoft'
  | 'acquisitions-incorporated'
  | 'ad'
  | 'address-book'
  | 'address-card'
  | 'adjust'
  | 'adn'
  | 'adversal'
  | 'affiliatetheme'
  | 'air-freshener'
  | 'airbnb'
  | 'algolia'
  | 'align-center'
  | 'align-justify'
  | 'align-left'
  | 'align-right'
  | 'alipay'
  | 'allergies'
  | 'amazon-pay'
  | 'amazon'
  | 'ambulance'
  | 'american-sign-language-interpreting'
  | 'amilia'
  | 'anchor'
  | 'android'
  | 'angellist'
  | 'angle-double-down'
  | 'angle-double-left'
  | 'angle-double-right'
  | 'angle-double-up'
  | 'angle-down'
  | 'angle-left'
  | 'angle-right'
  | 'angle-up'
  | 'angry'
  | 'angrycreative'
  | 'angular'
  | 'ankh'
  | 'app-store-ios'
  | 'app-store'
  | 'apper'
  | 'apple-alt'
  | 'apple-pay'
  | 'apple'
  | 'archive'
  | 'archway'
  | 'arrow-alt-circle-down'
  | 'arrow-alt-circle-left'
  | 'arrow-alt-circle-right'
  | 'arrow-alt-circle-up'
  | 'arrow-circle-down'
  | 'arrow-circle-left'
  | 'arrow-circle-right'
  | 'arrow-circle-up'
  | 'arrow-down'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up'
  | 'arrows-alt-h'
  | 'arrows-alt-v'
  | 'arrows-alt'
  | 'artstation'
  | 'assistive-listening-systems'
  | 'asterisk'
  | 'asymmetrik'
  | 'at'
  | 'atlas'
  | 'atlassian'
  | 'atom'
  | 'audible'
  | 'audio-description'
  | 'autoprefixer'
  | 'avianex'
  | 'aviato'
  | 'award'
  | 'aws'
  | 'baby-carriage'
  | 'baby'
  | 'backspace'
  | 'backward'
  | 'bacon'
  | 'bacteria'
  | 'bacterium'
  | 'bahai'
  | 'balance-scale-left'
  | 'balance-scale-right'
  | 'balance-scale'
  | 'ban'
  | 'band-aid'
  | 'bandcamp'
  | 'barcode'
  | 'bars'
  | 'baseball-ball'
  | 'basketball-ball'
  | 'bath'
  | 'battery-empty'
  | 'battery-full'
  | 'battery-half'
  | 'battery-quarter'
  | 'battery-three-quarters'
  | 'battle-net'
  | 'bed'
  | 'beer'
  | 'behance-square'
  | 'behance'
  | 'bell-slash'
  | 'bell'
  | 'bezier-curve'
  | 'bible'
  | 'bicycle'
  | 'biking'
  | 'bimobject'
  | 'binoculars'
  | 'biohazard'
  | 'birthday-cake'
  | 'bitbucket'
  | 'bitcoin'
  | 'bity'
  | 'black-tie'
  | 'blackberry'
  | 'blender-phone'
  | 'blender'
  | 'blind'
  | 'blog'
  | 'blogger-b'
  | 'blogger'
  | 'bluetooth-b'
  | 'bluetooth'
  | 'bold'
  | 'bolt'
  | 'bomb'
  | 'bone'
  | 'bong'
  | 'book-dead'
  | 'book-medical'
  | 'book-open'
  | 'book-reader'
  | 'book'
  | 'bookmark'
  | 'bootstrap'
  | 'border-all'
  | 'border-none'
  | 'border-style'
  | 'bowling-ball'
  | 'box-open'
  | 'box-tissue'
  | 'box'
  | 'boxes'
  | 'braille'
  | 'brain'
  | 'bread-slice'
  | 'briefcase-medical'
  | 'briefcase'
  | 'broadcast-tower'
  | 'broom'
  | 'brush'
  | 'btc'
  | 'buffer'
  | 'bug'
  | 'building'
  | 'bullhorn'
  | 'bullseye'
  | 'burn'
  | 'buromobelexperte'
  | 'bus-alt'
  | 'bus'
  | 'business-time'
  | 'buy-n-large'
  | 'buysellads'
  | 'calculator'
  | 'calendar-alt'
  | 'calendar-check'
  | 'calendar-day'
  | 'calendar-minus'
  | 'calendar-plus'
  | 'calendar-times'
  | 'calendar-week'
  | 'calendar'
  | 'camera-retro'
  | 'camera'
  | 'campground'
  | 'canadian-maple-leaf'
  | 'candy-cane'
  | 'cannabis'
  | 'capsules'
  | 'car-alt'
  | 'car-battery'
  | 'car-crash'
  | 'car-side'
  | 'car'
  | 'caravan'
  | 'caret-down'
  | 'caret-left'
  | 'caret-right'
  | 'caret-square-down'
  | 'caret-square-left'
  | 'caret-square-right'
  | 'caret-square-up'
  | 'caret-up'
  | 'carrot'
  | 'cart-arrow-down'
  | 'cart-plus'
  | 'cash-register'
  | 'cat'
  | 'cc-amazon-pay'
  | 'cc-amex'
  | 'cc-apple-pay'
  | 'cc-diners-club'
  | 'cc-discover'
  | 'cc-jcb'
  | 'cc-mastercard'
  | 'cc-paypal'
  | 'cc-stripe'
  | 'cc-visa'
  | 'centercode'
  | 'centos'
  | 'certificate'
  | 'chair'
  | 'chalkboard-teacher'
  | 'chalkboard'
  | 'charging-station'
  | 'chart-area'
  | 'chart-bar'
  | 'chart-line'
  | 'chart-pie'
  | 'check-circle'
  | 'check-double'
  | 'check-square'
  | 'check'
  | 'cheese'
  | 'chess-bishop'
  | 'chess-board'
  | 'chess-king'
  | 'chess-knight'
  | 'chess-pawn'
  | 'chess-queen'
  | 'chess-rook'
  | 'chess'
  | 'chevron-circle-down'
  | 'chevron-circle-left'
  | 'chevron-circle-right'
  | 'chevron-circle-up'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'child'
  | 'chrome'
  | 'chromecast'
  | 'church'
  | 'circle-notch'
  | 'circle'
  | 'city'
  | 'clinic-medical'
  | 'clipboard-check'
  | 'clipboard-list'
  | 'clipboard'
  | 'clock'
  | 'clone'
  | 'closed-captioning'
  | 'cloud-download-alt'
  | 'cloud-meatball'
  | 'cloud-moon-rain'
  | 'cloud-moon'
  | 'cloud-rain'
  | 'cloud-showers-heavy'
  | 'cloud-sun-rain'
  | 'cloud-sun'
  | 'cloud-upload-alt'
  | 'cloud'
  | 'cloudflare'
  | 'cloudscale'
  | 'cloudsmith'
  | 'cloudversify'
  | 'cocktail'
  | 'code-branch'
  | 'code'
  | 'codepen'
  | 'codiepie'
  | 'coffee'
  | 'cog'
  | 'cogs'
  | 'coins'
  | 'columns'
  | 'comment-alt'
  | 'comment-dollar'
  | 'comment-dots'
  | 'comment-medical'
  | 'comment-slash'
  | 'comment'
  | 'comments-dollar'
  | 'comments'
  | 'compact-disc'
  | 'compass'
  | 'compress-alt'
  | 'compress-arrows-alt'
  | 'compress'
  | 'concierge-bell'
  | 'confluence'
  | 'connectdevelop'
  | 'contao'
  | 'cookie-bite'
  | 'cookie'
  | 'copy'
  | 'copyright'
  | 'cotton-bureau'
  | 'couch'
  | 'cpanel'
  | 'creative-commons-by'
  | 'creative-commons-nc-eu'
  | 'creative-commons-nc-jp'
  | 'creative-commons-nc'
  | 'creative-commons-nd'
  | 'creative-commons-pd-alt'
  | 'creative-commons-pd'
  | 'creative-commons-remix'
  | 'creative-commons-sa'
  | 'creative-commons-sampling-plus'
  | 'creative-commons-sampling'
  | 'creative-commons-share'
  | 'creative-commons-zero'
  | 'creative-commons'
  | 'credit-card'
  | 'critical-role'
  | 'crop-alt'
  | 'crop'
  | 'cross'
  | 'crosshairs'
  | 'crow'
  | 'crown'
  | 'crutch'
  | 'css3-alt'
  | 'css3'
  | 'cube'
  | 'cubes'
  | 'cut'
  | 'cuttlefish'
  | 'd-and-d-beyond'
  | 'd-and-d'
  | 'dailymotion'
  | 'dashcube'
  | 'database'
  | 'deaf'
  | 'deezer'
  | 'delicious'
  | 'democrat'
  | 'deploydog'
  | 'deskpro'
  | 'desktop'
  | 'dev'
  | 'deviantart'
  | 'dharmachakra'
  | 'dhl'
  | 'diagnoses'
  | 'diaspora'
  | 'dice-d20'
  | 'dice-d6'
  | 'dice-five'
  | 'dice-four'
  | 'dice-one'
  | 'dice-six'
  | 'dice-three'
  | 'dice-two'
  | 'dice'
  | 'digg'
  | 'digital-ocean'
  | 'digital-tachograph'
  | 'directions'
  | 'discord'
  | 'discourse'
  | 'disease'
  | 'divide'
  | 'dizzy'
  | 'dna'
  | 'dochub'
  | 'docker'
  | 'dog'
  | 'dollar-sign'
  | 'dolly-flatbed'
  | 'dolly'
  | 'donate'
  | 'door-closed'
  | 'door-open'
  | 'dot-circle'
  | 'dove'
  | 'download'
  | 'draft2digital'
  | 'drafting-compass'
  | 'dragon'
  | 'draw-polygon'
  | 'dribbble-square'
  | 'dribbble'
  | 'dropbox'
  | 'drum-steelpan'
  | 'drum'
  | 'drumstick-bite'
  | 'drupal'
  | 'dumbbell'
  | 'dumpster-fire'
  | 'dumpster'
  | 'dungeon'
  | 'dyalog'
  | 'earlybirds'
  | 'ebay'
  | 'edge-legacy'
  | 'edge'
  | 'edit'
  | 'egg'
  | 'eject'
  | 'elementor'
  | 'ellipsis-h'
  | 'ellipsis-v'
  | 'ello'
  | 'ember'
  | 'empire'
  | 'envelope-open-text'
  | 'envelope-open'
  | 'envelope-square'
  | 'envelope'
  | 'envira'
  | 'equals'
  | 'eraser'
  | 'erlang'
  | 'ethereum'
  | 'ethernet'
  | 'etsy'
  | 'euro-sign'
  | 'evernote'
  | 'exchange-alt'
  | 'exclamation-circle'
  | 'exclamation-triangle'
  | 'exclamation'
  | 'expand-alt'
  | 'expand-arrows-alt'
  | 'expand'
  | 'expeditedssl'
  | 'external-link-alt'
  | 'external-link-square-alt'
  | 'eye-dropper'
  | 'eye-slash'
  | 'eye'
  | 'facebook-f'
  | 'facebook-messenger'
  | 'facebook-square'
  | 'facebook'
  | 'fan'
  | 'fantasy-flight-games'
  | 'fast-backward'
  | 'fast-forward'
  | 'faucet'
  | 'fax'
  | 'feather-alt'
  | 'feather'
  | 'fedex'
  | 'fedora'
  | 'female'
  | 'fighter-jet'
  | 'figma'
  | 'file-alt'
  | 'file-archive'
  | 'file-audio'
  | 'file-code'
  | 'file-contract'
  | 'file-csv'
  | 'file-download'
  | 'file-excel'
  | 'file-export'
  | 'file-image'
  | 'file-import'
  | 'file-invoice-dollar'
  | 'file-invoice'
  | 'file-medical-alt'
  | 'file-medical'
  | 'file-pdf'
  | 'file-powerpoint'
  | 'file-prescription'
  | 'file-signature'
  | 'file-upload'
  | 'file-video'
  | 'file-word'
  | 'file'
  | 'fill-drip'
  | 'fill'
  | 'film'
  | 'filter'
  | 'fingerprint'
  | 'fire-alt'
  | 'fire-extinguisher'
  | 'fire'
  | 'firefox-browser'
  | 'firefox'
  | 'first-aid'
  | 'first-order-alt'
  | 'first-order'
  | 'firstdraft'
  | 'fish'
  | 'fist-raised'
  | 'flag-checkered'
  | 'flag-usa'
  | 'flag'
  | 'flask'
  | 'flickr'
  | 'flipboard'
  | 'flushed'
  | 'fly'
  | 'folder-minus'
  | 'folder-open'
  | 'folder-plus'
  | 'folder'
  | 'font-awesome-alt'
  | 'font-awesome-flag'
  | 'font-awesome-logo-full'
  | 'font-awesome'
  | 'font'
  | 'fonticons-fi'
  | 'fonticons'
  | 'football-ball'
  | 'fort-awesome-alt'
  | 'fort-awesome'
  | 'forumbee'
  | 'forward'
  | 'foursquare'
  | 'free-code-camp'
  | 'freebsd'
  | 'frog'
  | 'frown-open'
  | 'frown'
  | 'fulcrum'
  | 'funnel-dollar'
  | 'futbol'
  | 'galactic-republic'
  | 'galactic-senate'
  | 'gamepad'
  | 'gas-pump'
  | 'gavel'
  | 'gem'
  | 'genderless'
  | 'get-pocket'
  | 'gg-circle'
  | 'gg'
  | 'ghost'
  | 'gift'
  | 'gifts'
  | 'git-alt'
  | 'git-square'
  | 'git'
  | 'github-alt'
  | 'github-square'
  | 'github'
  | 'gitkraken'
  | 'gitlab'
  | 'gitter'
  | 'glass-cheers'
  | 'glass-martini-alt'
  | 'glass-martini'
  | 'glass-whiskey'
  | 'glasses'
  | 'glide-g'
  | 'glide'
  | 'globe-africa'
  | 'globe-americas'
  | 'globe-asia'
  | 'globe-europe'
  | 'globe'
  | 'gofore'
  | 'golf-ball'
  | 'goodreads-g'
  | 'goodreads'
  | 'google-drive'
  | 'google-pay'
  | 'google-play'
  | 'google-plus-g'
  | 'google-plus-square'
  | 'google-plus'
  | 'google-wallet'
  | 'google'
  | 'gopuram'
  | 'graduation-cap'
  | 'gratipay'
  | 'grav'
  | 'greater-than-equal'
  | 'greater-than'
  | 'grimace'
  | 'grin-alt'
  | 'grin-beam-sweat'
  | 'grin-beam'
  | 'grin-hearts'
  | 'grin-squint-tears'
  | 'grin-squint'
  | 'grin-stars'
  | 'grin-tears'
  | 'grin-tongue-squint'
  | 'grin-tongue-wink'
  | 'grin-tongue'
  | 'grin-wink'
  | 'grin'
  | 'grip-horizontal'
  | 'grip-lines-vertical'
  | 'grip-lines'
  | 'grip-vertical'
  | 'gripfire'
  | 'grunt'
  | 'guilded'
  | 'guitar'
  | 'gulp'
  | 'h-square'
  | 'hacker-news-square'
  | 'hacker-news'
  | 'hackerrank'
  | 'hamburger'
  | 'hammer'
  | 'hamsa'
  | 'hand-holding-heart'
  | 'hand-holding-medical'
  | 'hand-holding-usd'
  | 'hand-holding-water'
  | 'hand-holding'
  | 'hand-lizard'
  | 'hand-middle-finger'
  | 'hand-paper'
  | 'hand-peace'
  | 'hand-point-down'
  | 'hand-point-left'
  | 'hand-point-right'
  | 'hand-point-up'
  | 'hand-pointer'
  | 'hand-rock'
  | 'hand-scissors'
  | 'hand-sparkles'
  | 'hand-spock'
  | 'hands-helping'
  | 'hands-wash'
  | 'hands'
  | 'handshake-alt-slash'
  | 'handshake-slash'
  | 'handshake'
  | 'hanukiah'
  | 'hard-hat'
  | 'hashtag'
  | 'hat-cowboy-side'
  | 'hat-cowboy'
  | 'hat-wizard'
  | 'hdd'
  | 'head-side-cough-slash'
  | 'head-side-cough'
  | 'head-side-mask'
  | 'head-side-virus'
  | 'heading'
  | 'headphones-alt'
  | 'headphones'
  | 'headset'
  | 'heart-broken'
  | 'heart'
  | 'heartbeat'
  | 'helicopter'
  | 'highlighter'
  | 'hiking'
  | 'hippo'
  | 'hips'
  | 'hire-a-helper'
  | 'history'
  | 'hive'
  | 'hockey-puck'
  | 'holly-berry'
  | 'home'
  | 'hooli'
  | 'hornbill'
  | 'horse-head'
  | 'horse'
  | 'hospital-alt'
  | 'hospital-symbol'
  | 'hospital-user'
  | 'hospital'
  | 'hot-tub'
  | 'hotdog'
  | 'hotel'
  | 'hotjar'
  | 'hourglass-end'
  | 'hourglass-half'
  | 'hourglass-start'
  | 'hourglass'
  | 'house-damage'
  | 'house-user'
  | 'houzz'
  | 'hryvnia'
  | 'html5'
  | 'hubspot'
  | 'i-cursor'
  | 'ice-cream'
  | 'icicles'
  | 'icons'
  | 'id-badge'
  | 'id-card-alt'
  | 'id-card'
  | 'ideal'
  | 'igloo'
  | 'image'
  | 'images'
  | 'imdb'
  | 'inbox'
  | 'indent'
  | 'industry'
  | 'infinity'
  | 'info-circle'
  | 'info'
  | 'innosoft'
  | 'instagram-square'
  | 'instagram'
  | 'instalod'
  | 'intercom'
  | 'internet-explorer'
  | 'invision'
  | 'ioxhost'
  | 'italic'
  | 'itch-io'
  | 'itunes-note'
  | 'itunes'
  | 'java'
  | 'jedi-order'
  | 'jedi'
  | 'jenkins'
  | 'jira'
  | 'joget'
  | 'joint'
  | 'joomla'
  | 'journal-whills'
  | 'js-square'
  | 'js'
  | 'jsfiddle'
  | 'kaaba'
  | 'kaggle'
  | 'key'
  | 'keybase'
  | 'keyboard'
  | 'keycdn'
  | 'khanda'
  | 'kickstarter-k'
  | 'kickstarter'
  | 'kiss-beam'
  | 'kiss-wink-heart'
  | 'kiss'
  | 'kiwi-bird'
  | 'korvue'
  | 'landmark'
  | 'language'
  | 'laptop-code'
  | 'laptop-house'
  | 'laptop-medical'
  | 'laptop'
  | 'laravel'
  | 'lastfm-square'
  | 'lastfm'
  | 'laugh-beam'
  | 'laugh-squint'
  | 'laugh-wink'
  | 'laugh'
  | 'layer-group'
  | 'leaf'
  | 'leanpub'
  | 'lemon'
  | 'less-than-equal'
  | 'less-than'
  | 'less'
  | 'level-down-alt'
  | 'level-up-alt'
  | 'life-ring'
  | 'lightbulb'
  | 'line'
  | 'link'
  | 'linkedin-in'
  | 'linkedin'
  | 'linode'
  | 'linux'
  | 'lira-sign'
  | 'list-alt'
  | 'list-ol'
  | 'list-ul'
  | 'list'
  | 'location-arrow'
  | 'lock-open'
  | 'lock'
  | 'long-arrow-alt-down'
  | 'long-arrow-alt-left'
  | 'long-arrow-alt-right'
  | 'long-arrow-alt-up'
  | 'low-vision'
  | 'luggage-cart'
  | 'lungs-virus'
  | 'lungs'
  | 'lyft'
  | 'magento'
  | 'magic'
  | 'magnet'
  | 'mail-bulk'
  | 'mailchimp'
  | 'male'
  | 'mandalorian'
  | 'map-marked-alt'
  | 'map-marked'
  | 'map-marker-alt'
  | 'map-marker'
  | 'map-pin'
  | 'map-signs'
  | 'map'
  | 'markdown'
  | 'marker'
  | 'mars-double'
  | 'mars-stroke-h'
  | 'mars-stroke-v'
  | 'mars-stroke'
  | 'mars'
  | 'mask'
  | 'mastodon'
  | 'maxcdn'
  | 'mdb'
  | 'medal'
  | 'medapps'
  | 'medium-m'
  | 'medium'
  | 'medkit'
  | 'medrt'
  | 'meetup'
  | 'megaport'
  | 'meh-blank'
  | 'meh-rolling-eyes'
  | 'meh'
  | 'memory'
  | 'mendeley'
  | 'menorah'
  | 'mercury'
  | 'meteor'
  | 'microblog'
  | 'microchip'
  | 'microphone-alt-slash'
  | 'microphone-alt'
  | 'microphone-slash'
  | 'microphone'
  | 'microscope'
  | 'microsoft'
  | 'minus-circle'
  | 'minus-square'
  | 'minus'
  | 'mitten'
  | 'mix'
  | 'mixcloud'
  | 'mixer'
  | 'mizuni'
  | 'mobile-alt'
  | 'mobile'
  | 'modx'
  | 'monero'
  | 'money-bill-alt'
  | 'money-bill-wave-alt'
  | 'money-bill-wave'
  | 'money-bill'
  | 'money-check-alt'
  | 'money-check'
  | 'monument'
  | 'moon'
  | 'mortar-pestle'
  | 'mosque'
  | 'motorcycle'
  | 'mountain'
  | 'mouse-pointer'
  | 'mouse'
  | 'mug-hot'
  | 'music'
  | 'napster'
  | 'neos'
  | 'network-wired'
  | 'neuter'
  | 'newspaper'
  | 'nimblr'
  | 'node-js'
  | 'node'
  | 'not-equal'
  | 'notes-medical'
  | 'npm'
  | 'ns8'
  | 'nutritionix'
  | 'object-group'
  | 'object-ungroup'
  | 'octopus-deploy'
  | 'odnoklassniki-square'
  | 'odnoklassniki'
  | 'oil-can'
  | 'old-republic'
  | 'om'
  | 'opencart'
  | 'openid'
  | 'opera'
  | 'optin-monster'
  | 'orcid'
  | 'osi'
  | 'otter'
  | 'outdent'
  | 'page4'
  | 'pagelines'
  | 'pager'
  | 'paint-brush'
  | 'paint-roller'
  | 'palette'
  | 'palfed'
  | 'pallet'
  | 'paper-plane'
  | 'paperclip'
  | 'parachute-box'
  | 'paragraph'
  | 'parking'
  | 'passport'
  | 'pastafarianism'
  | 'paste'
  | 'patreon'
  | 'pause-circle'
  | 'pause'
  | 'paw'
  | 'paypal'
  | 'peace'
  | 'pen-alt'
  | 'pen-fancy'
  | 'pen-nib'
  | 'pen-square'
  | 'pen'
  | 'pencil-alt'
  | 'pencil-ruler'
  | 'penny-arcade'
  | 'people-arrows'
  | 'people-carry'
  | 'pepper-hot'
  | 'perbyte'
  | 'percent'
  | 'percentage'
  | 'periscope'
  | 'person-booth'
  | 'phabricator'
  | 'phoenix-framework'
  | 'phoenix-squadron'
  | 'phone-alt'
  | 'phone-slash'
  | 'phone-square-alt'
  | 'phone-square'
  | 'phone-volume'
  | 'phone'
  | 'photo-video'
  | 'php'
  | 'pied-piper-alt'
  | 'pied-piper-hat'
  | 'pied-piper-pp'
  | 'pied-piper-square'
  | 'pied-piper'
  | 'piggy-bank'
  | 'pills'
  | 'pinterest-p'
  | 'pinterest-square'
  | 'pinterest'
  | 'pizza-slice'
  | 'place-of-worship'
  | 'plane-arrival'
  | 'plane-departure'
  | 'plane-slash'
  | 'plane'
  | 'play-circle'
  | 'play'
  | 'playstation'
  | 'plug'
  | 'plus-circle'
  | 'plus-square'
  | 'plus'
  | 'podcast'
  | 'poll-h'
  | 'poll'
  | 'poo-storm'
  | 'poo'
  | 'poop'
  | 'portrait'
  | 'pound-sign'
  | 'power-off'
  | 'pray'
  | 'praying-hands'
  | 'prescription-bottle-alt'
  | 'prescription-bottle'
  | 'prescription'
  | 'print'
  | 'procedures'
  | 'product-hunt'
  | 'project-diagram'
  | 'pump-medical'
  | 'pump-soap'
  | 'pushed'
  | 'puzzle-piece'
  | 'python'
  | 'qq'
  | 'qrcode'
  | 'question-circle'
  | 'question'
  | 'quidditch'
  | 'quinscape'
  | 'quora'
  | 'quote-left'
  | 'quote-right'
  | 'quran'
  | 'r-project'
  | 'radiation-alt'
  | 'radiation'
  | 'rainbow'
  | 'random'
  | 'raspberry-pi'
  | 'ravelry'
  | 'react'
  | 'reacteurope'
  | 'readme'
  | 'rebel'
  | 'receipt'
  | 'record-vinyl'
  | 'recycle'
  | 'red-river'
  | 'reddit-alien'
  | 'reddit-square'
  | 'reddit'
  | 'redhat'
  | 'redo-alt'
  | 'redo'
  | 'registered'
  | 'remove-format'
  | 'renren'
  | 'reply-all'
  | 'reply'
  | 'replyd'
  | 'republican'
  | 'researchgate'
  | 'resolving'
  | 'restroom'
  | 'retweet'
  | 'rev'
  | 'ribbon'
  | 'ring'
  | 'road'
  | 'robot'
  | 'rocket'
  | 'rocketchat'
  | 'rockrms'
  | 'route'
  | 'rss-square'
  | 'rss'
  | 'ruble-sign'
  | 'ruler-combined'
  | 'ruler-horizontal'
  | 'ruler-vertical'
  | 'ruler'
  | 'running'
  | 'rupee-sign'
  | 'rust'
  | 'sad-cry'
  | 'sad-tear'
  | 'safari'
  | 'salesforce'
  | 'sass'
  | 'satellite-dish'
  | 'satellite'
  | 'save'
  | 'schlix'
  | 'school'
  | 'screwdriver'
  | 'scribd'
  | 'scroll'
  | 'sd-card'
  | 'search-dollar'
  | 'search-location'
  | 'search-minus'
  | 'search-plus'
  | 'search'
  | 'searchengin'
  | 'seedling'
  | 'sellcast'
  | 'sellsy'
  | 'server'
  | 'servicestack'
  | 'shapes'
  | 'share-alt-square'
  | 'share-alt'
  | 'share-square'
  | 'share'
  | 'shekel-sign'
  | 'shield-alt'
  | 'shield-virus'
  | 'ship'
  | 'shipping-fast'
  | 'shirtsinbulk'
  | 'shoe-prints'
  | 'shopify'
  | 'shopping-bag'
  | 'shopping-basket'
  | 'shopping-cart'
  | 'shopware'
  | 'shower'
  | 'shuttle-van'
  | 'sign-in-alt'
  | 'sign-language'
  | 'sign-out-alt'
  | 'sign'
  | 'signal'
  | 'signature'
  | 'sim-card'
  | 'simplybuilt'
  | 'sink'
  | 'sistrix'
  | 'sitemap'
  | 'sith'
  | 'skating'
  | 'sketch'
  | 'skiing-nordic'
  | 'skiing'
  | 'skull-crossbones'
  | 'skull'
  | 'skyatlas'
  | 'skype'
  | 'slack-hash'
  | 'slack'
  | 'slash'
  | 'sleigh'
  | 'sliders-h'
  | 'slideshare'
  | 'smile-beam'
  | 'smile-wink'
  | 'smile'
  | 'smog'
  | 'smoking-ban'
  | 'smoking'
  | 'sms'
  | 'snapchat-ghost'
  | 'snapchat-square'
  | 'snapchat'
  | 'snowboarding'
  | 'snowflake'
  | 'snowman'
  | 'snowplow'
  | 'soap'
  | 'socks'
  | 'solar-panel'
  | 'sort-alpha-down-alt'
  | 'sort-alpha-down'
  | 'sort-alpha-up-alt'
  | 'sort-alpha-up'
  | 'sort-amount-down-alt'
  | 'sort-amount-down'
  | 'sort-amount-up-alt'
  | 'sort-amount-up'
  | 'sort-down'
  | 'sort-numeric-down-alt'
  | 'sort-numeric-down'
  | 'sort-numeric-up-alt'
  | 'sort-numeric-up'
  | 'sort-up'
  | 'sort'
  | 'soundcloud'
  | 'sourcetree'
  | 'spa'
  | 'space-shuttle'
  | 'speakap'
  | 'speaker-deck'
  | 'spell-check'
  | 'spider'
  | 'spinner'
  | 'splotch'
  | 'spotify'
  | 'spray-can'
  | 'square-full'
  | 'square-root-alt'
  | 'square'
  | 'squarespace'
  | 'stack-exchange'
  | 'stack-overflow'
  | 'stackpath'
  | 'stamp'
  | 'star-and-crescent'
  | 'star-half-alt'
  | 'star-half'
  | 'star-of-david'
  | 'star-of-life'
  | 'star'
  | 'staylinked'
  | 'steam-square'
  | 'steam-symbol'
  | 'steam'
  | 'step-backward'
  | 'step-forward'
  | 'stethoscope'
  | 'sticker-mule'
  | 'sticky-note'
  | 'stop-circle'
  | 'stop'
  | 'stopwatch-20'
  | 'stopwatch'
  | 'store-alt-slash'
  | 'store-alt'
  | 'store-slash'
  | 'store'
  | 'strava'
  | 'stream'
  | 'street-view'
  | 'strikethrough'
  | 'stripe-s'
  | 'stripe'
  | 'stroopwafel'
  | 'studiovinari'
  | 'stumbleupon-circle'
  | 'stumbleupon'
  | 'subscript'
  | 'subway'
  | 'suitcase-rolling'
  | 'suitcase'
  | 'sun'
  | 'superpowers'
  | 'superscript'
  | 'supple'
  | 'surprise'
  | 'suse'
  | 'swatchbook'
  | 'swift'
  | 'swimmer'
  | 'swimming-pool'
  | 'symfony'
  | 'synagogue'
  | 'sync-alt'
  | 'sync'
  | 'syringe'
  | 'table-tennis'
  | 'table'
  | 'tablet-alt'
  | 'tablet'
  | 'tablets'
  | 'tachometer-alt'
  | 'tag'
  | 'tags'
  | 'tape'
  | 'tasks'
  | 'taxi'
  | 'teamspeak'
  | 'teeth-open'
  | 'teeth'
  | 'telegram-plane'
  | 'telegram'
  | 'temperature-high'
  | 'temperature-low'
  | 'tencent-weibo'
  | 'tenge'
  | 'terminal'
  | 'text-height'
  | 'text-width'
  | 'th-large'
  | 'th-list'
  | 'th'
  | 'the-red-yeti'
  | 'theater-masks'
  | 'themeco'
  | 'themeisle'
  | 'thermometer-empty'
  | 'thermometer-full'
  | 'thermometer-half'
  | 'thermometer-quarter'
  | 'thermometer-three-quarters'
  | 'thermometer'
  | 'think-peaks'
  | 'thumbs-down'
  | 'thumbs-up'
  | 'thumbtack'
  | 'ticket-alt'
  | 'tiktok'
  | 'times-circle'
  | 'times'
  | 'tint-slash'
  | 'tint'
  | 'tired'
  | 'toggle-off'
  | 'toggle-on'
  | 'toilet-paper-slash'
  | 'toilet-paper'
  | 'toilet'
  | 'toolbox'
  | 'tools'
  | 'tooth'
  | 'torah'
  | 'torii-gate'
  | 'tractor'
  | 'trade-federation'
  | 'trademark'
  | 'traffic-light'
  | 'trailer'
  | 'train'
  | 'tram'
  | 'transgender-alt'
  | 'transgender'
  | 'trash-alt'
  | 'trash-restore-alt'
  | 'trash-restore'
  | 'trash'
  | 'tree'
  | 'trello'
  | 'tripadvisor'
  | 'trophy'
  | 'truck-loading'
  | 'truck-monster'
  | 'truck-moving'
  | 'truck-pickup'
  | 'truck'
  | 'tshirt'
  | 'tty'
  | 'tumblr-square'
  | 'tumblr'
  | 'tv'
  | 'twitch'
  | 'twitter-square'
  | 'twitter'
  | 'typo3'
  | 'uber'
  | 'ubuntu'
  | 'uikit'
  | 'umbraco'
  | 'umbrella-beach'
  | 'umbrella'
  | 'uncharted'
  | 'underline'
  | 'undo-alt'
  | 'undo'
  | 'uniregistry'
  | 'unity'
  | 'universal-access'
  | 'university'
  | 'unlink'
  | 'unlock-alt'
  | 'unlock'
  | 'unsplash'
  | 'untappd'
  | 'upload'
  | 'ups'
  | 'usb'
  | 'user-alt-slash'
  | 'user-alt'
  | 'user-astronaut'
  | 'user-check'
  | 'user-circle'
  | 'user-clock'
  | 'user-cog'
  | 'user-edit'
  | 'user-friends'
  | 'user-graduate'
  | 'user-injured'
  | 'user-lock'
  | 'user-md'
  | 'user-minus'
  | 'user-ninja'
  | 'user-nurse'
  | 'user-plus'
  | 'user-secret'
  | 'user-shield'
  | 'user-slash'
  | 'user-tag'
  | 'user-tie'
  | 'user-times'
  | 'user'
  | 'users-cog'
  | 'users-slash'
  | 'users'
  | 'usps'
  | 'ussunnah'
  | 'utensil-spoon'
  | 'utensils'
  | 'vaadin'
  | 'vector-square'
  | 'venus-double'
  | 'venus-mars'
  | 'venus'
  | 'vest-patches'
  | 'vest'
  | 'viacoin'
  | 'viadeo-square'
  | 'viadeo'
  | 'vial'
  | 'vials'
  | 'viber'
  | 'video-slash'
  | 'video'
  | 'vihara'
  | 'vimeo-square'
  | 'vimeo-v'
  | 'vimeo'
  | 'vine'
  | 'virus-slash'
  | 'virus'
  | 'viruses'
  | 'vk'
  | 'vnv'
  | 'voicemail'
  | 'volleyball-ball'
  | 'volume-down'
  | 'volume-mute'
  | 'volume-off'
  | 'volume-up'
  | 'vote-yea'
  | 'vr-cardboard'
  | 'vuejs'
  | 'walking'
  | 'wallet'
  | 'warehouse'
  | 'watchman-monitoring'
  | 'water'
  | 'wave-square'
  | 'waze'
  | 'weebly'
  | 'weibo'
  | 'weight-hanging'
  | 'weight'
  | 'weixin'
  | 'whatsapp-square'
  | 'whatsapp'
  | 'wheelchair'
  | 'whmcs'
  | 'wifi'
  | 'wikipedia-w'
  | 'wind'
  | 'window-close'
  | 'window-maximize'
  | 'window-minimize'
  | 'window-restore'
  | 'windows'
  | 'wine-bottle'
  | 'wine-glass-alt'
  | 'wine-glass'
  | 'wix'
  | 'wizards-of-the-coast'
  | 'wodu'
  | 'wolf-pack-battalion'
  | 'won-sign'
  | 'wordpress-simple'
  | 'wordpress'
  | 'wpbeginner'
  | 'wpexplorer'
  | 'wpforms'
  | 'wpressr'
  | 'wrench'
  | 'x-ray'
  | 'xbox'
  | 'xing-square'
  | 'xing'
  | 'y-combinator'
  | 'yahoo'
  | 'yammer'
  | 'yandex-international'
  | 'yandex'
  | 'yarn'
  | 'yelp'
  | 'yen-sign'
  | 'yin-yang'
  | 'yoast'
  | 'youtube-square'
  | 'youtube'
  | 'zhihu';
